import { STEP_STUDIES_ACTION_TYPES } from 'store/actions/studies.actions';

const initialState = {
  isFormProcessed: false,
  currentStudies: [],
  allStudies: [],
};

export default function (state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case STEP_STUDIES_ACTION_TYPES.STEP_STUDIES_ALL:
      return { ...state, allStudies: payload.data };

    case STEP_STUDIES_ACTION_TYPES.STEP_STUDIES_ADDED_STATE:
      return { ...state, currentStudies: payload };

    case STEP_STUDIES_ACTION_TYPES.STEP_STUDIES_CHANGE_PROCESSING:
      return { ...state, isFormProcessed: payload };

    default:
      return state;
  }
}
